/**
 * Shared helpers for the StatefulMacroCoordinator.
 */

/**
 * Generate a fresh run id used to scope a native macro run to a single
 * launch attempt. The host owns this id end-to-end; Playjector echoes it back
 * so late replies for a superseded run can be dropped.
 */
export function generateRunId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `run-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
